"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderBackButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const hooks_1 = require("@alfalab/hooks");
const ArrowBackHeavyMIcon_1 = require("@alfalab/icons-glyph/ArrowBackHeavyMIcon");
const ArrowBackMIcon_1 = require("@alfalab/icons-glyph/ArrowBackMIcon");
const service_button_1 = require("../../../service-button");
const component_context_1 = require("../../context/component.context");
const index_module_css_1 = __importDefault(require("./index.module.css"));
const HeaderBackButton = ({ onClick, rightAddons }) => {
    const { isResponsive, isDesktop } = (0, react_1.useContext)(component_context_1.AdditionalContext);
    const [isDesktopMedia] = (0, hooks_1.useMedia)([[true, '(min-width: 1280px)']], false);
    const isResponsiveDesktop = isDesktopMedia && isResponsive;
    const LeftAddon = isDesktop || isResponsiveDesktop ? ArrowBackHeavyMIcon_1.ArrowBackHeavyMIcon : ArrowBackMIcon_1.ArrowBackMIcon;
    return ((0, jsx_runtime_1.jsxs)("div", { className: index_module_css_1.default.actionsWrapper, children: [(0, jsx_runtime_1.jsx)(service_button_1.ServiceButton, { "aria-label": '\u041D\u0430\u0437\u0430\u0434', dataTestId: 'side-panel-header-back', className: (0, classnames_1.default)(index_module_css_1.default.button, {
                    [index_module_css_1.default.desktop]: isResponsiveDesktop || isDesktop,
                }), onClick: onClick, leftAddon: (0, jsx_runtime_1.jsx)(LeftAddon, {}), leftAddonBackground: true, leftAddonClassName: (0, classnames_1.default)({
                    [index_module_css_1.default.leftAddon]: isResponsiveDesktop || isDesktop,
                }) }), (0, jsx_runtime_1.jsx)("div", { children: rightAddons })] }));
};
exports.HeaderBackButton = HeaderBackButton;
